export default "__VITE_ASSET__CS0_MX8V__"